import { useState, useCallback } from 'react';

export type SearchMode = 'simple' | 'advanced';

export interface UseSearchModeReturn {
  mode: SearchMode;
  setMode: (mode: SearchMode) => void;
  toggleMode: () => void;
  isSimple: boolean;
  isAdvanced: boolean;
}

export function useSearchMode(initialMode: SearchMode = 'simple'): UseSearchModeReturn {
  const [mode, setMode] = useState<SearchMode>(initialMode);

  const toggleMode = useCallback(() => {
    setMode((prev) => (prev === 'simple' ? 'advanced' : 'simple'));
  }, []);

  return {
    mode,
    setMode,
    toggleMode,
    isSimple: mode === 'simple',
    isAdvanced: mode === 'advanced',
  };
}
